export const TotalSummary = [
    {
      title: "Total  OTP sent",
      total: 1200,
    },
   
  ];